export default {
  introduction: 'Introduction',
  turnOff: 'close',
  progress: 'Progress',
  Fold: 'Fold',
  Unfold: 'Unfold',
  fillInAnswer: 'Please key in your answer',
  qustionAnswer: 'Q & A',
  qustionAnswer2: 'Q & A',
  singleChoice: 'Single choice',
  multipleChoice: 'Multiple choice',
  tit_sin: 'Single Choice Drag',
  tit_mul: 'Multiple Options Drag',
  fillInBlank: 'Fill in the blanks',
  fillInBlank2: 'Fill in the blanks',
  fillInBlank3: 'Fill in the blanks',
  tureOrFalse: 'Ture or False',
  tureOrFalse2: 'Ture or False',
  reference: 'Reference',
  parsing: 'Feedback',
  submit: 'Submit',
  correct: 'true',
  wrong: 'false',
  answerFeedback: 'Feedback',
  correctAnswer: 'Correct answer',
  questionParsing: 'Feedback',
  beforeSubmit: 'Please submit after finishing all questions.',
  Finished: 'Finished',
  Opening: 'Opening',
  EndVideo: 'End',
  IllustrationType: 'Illustration',
  learnExam: 'Quiz',
  Enter: 'Enter',
  Deatil: 'Details',
  collapse: 'close',
  contents: 'Back',
  prevChapter: 'Previous',
  nextChapter: 'Next',
  answerTrue: 'Correct',
  answerFalse: 'Wrong',
  view: 'View',
  Matching: ' Matching - Single choice',
  Matching2: 'Matching - Multiple choice',
  scromLoadFailed: 'Scorm loading failed',
  audioLoadFailed: 'Audio loading failed',
  audioPlayback: 'Audio playback failed， Please click to play audio',
  finishedSubmit: 'You’ve got required questions to answer',
  pageBack: ' Back '
}
